import { Module } from 'vuex-smart-module';
import CompanyUserStaffActions from './actions';
import CompanyUserStaffGetters from './getters';
import CompanyUserStaffMutations from './mutations';
import CompanyUserStaffState from './state';

export default new Module({
  state: CompanyUserStaffState,
  mutations: CompanyUserStaffMutations,
  actions: CompanyUserStaffActions,
  getters: CompanyUserStaffGetters,
});
